// src/lib/firebase.js
// ─────────────────────────────────────────────────────────
// HOW TO SET UP:
// 1. Go to console.firebase.google.com
// 2. Create a new project called "signalpost"
// 3. Add a Web app (the </> icon)
// 4. Copy your firebaseConfig object and paste it below
// 5. In the Firebase console, enable:
//    - Firestore Database (start in production mode)
//    - Hosting
//    - Analytics (for SU-03)
// ─────────────────────────────────────────────────────────

import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics, logEvent } from 'firebase/analytics';

// Replace this with YOUR firebaseConfig from the Firebase console
// Project Settings → Your apps → Firebase SDK snippet → Config
const firebaseConfig = {
  apiKey:            process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain:        process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId:         process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket:     process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId:             process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId:     process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const app       = initializeApp(firebaseConfig);
export const db = getFirestore(app);

// Analytics — safe to call even if measurementId is missing
let analytics = null;
try { analytics = getAnalytics(app); } catch (e) { /* not available in dev */ }

// ─── SU-03: analytics event logger ───────────────────────
// Call this anywhere in the app to record usage for grant reports.
// Events land in Firebase Analytics → DebugView in dev,
// and in the Events dashboard in production.
export function track(eventName, params = {}) {
  if (analytics) logEvent(analytics, eventName, params);
  if (process.env.NODE_ENV === 'development') {
    console.log('[analytics]', eventName, params);
  }
}

// Event name constants — import these instead of typing strings
export const EVENTS = {
  SEARCH:           'search_performed',
  FILTER_APPLIED:   'filter_applied',
  PROGRAM_VIEWED:   'program_viewed',
  WIZARD_STARTED:   'wizard_started',
  WIZARD_COMPLETED: 'wizard_completed',
  WIZARD_SKIPPED:   'wizard_skipped',
  PROGRAM_FLAGGED:  'program_flagged',
  PROGRAM_SUBMITTED:'program_submitted',
  AI_CHAT_OPENED:   'ai_chat_opened',
  AI_MESSAGE_SENT:  'ai_message_sent',
};
